module.exports = __webpack_public_path__ + "static/media/ope_merja_902x1353.6ddf3b4c.jpg";